/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Persons from './Persons/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Address/Related/Content/Popup/Content"
  
}) {
let emailEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'email.address',
})
let dtColorsBlue100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsBlue700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.700'
        })
let constantData = 'There are'
let sameEmailPersonsLengthValueData = fromData.useDataValue({ viewPath,
context: 'same_email_persons',
path: 'length',
})
let constantData1 = 'other people currently associated with this email.'
let aggregateData = fromAggregate.join(constantData, sameEmailPersonsLengthValueData, constantData1)
let dtColorsBlue600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.600'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height={400}
 width={600}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h5"
 data="email.email.address"
 text={emailEmailAddressValueData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsBlue100,'--bblr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-8-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 fill={dtColorsBlue700}
 marginRight={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsBlue600}
 fontSize={dtTypographyFontsizeM}
 data="'There are'"
 data="same_email_persons.length"
 data="'other people currently associated with this email.'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
</div>
<Persons
  viewPath={`${viewPath}/Persons`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}